// extracted by mini-css-extract-plugin
export var hideEditor = "_no-2";
export var infoIcon = "_no-3";
export var label = "_no-1";
export var labelContainer = "_no-0";
export var readonlyText = "_no-4";